/* global data, config */
import { redirect } from "react-router-dom";
import { USER_ROLES } from "constants";
import { trackEvent } from "../configureMixpanel";

export async function getLoggedInUser() {
  const { user } = data;
  if (typeof user === "object") {
    user["claims"] = {
      isSuperUser: user?.is_superuser ?? false,
      isStaff: user?.is_staff ?? false,
    };
  }
  return user;
}

export async function requireAuthedUser({ request }) {
  if (!request) {
    throw Error("No request property in provided route context object");
  }

  const url  = new URL(request.url);
  const { user: loggedInUser } = data;

  if (!loggedInUser && !["/forgot-password", "/reset-password"].includes(url.pathname)) {
    const { url } = request;
    const redirectRoute = new URL(url)?.pathname ?? "";
    const maybeRedirectParams = redirectRoute
      ? `?${new URLSearchParams({ redirectRoute })?.toString()}`
      : "";

    // Named for what's actually observable here - an unauthenticated visit to
    // a protected route - not "auth_session_expired", since this fires
    // identically for a real session timeout and a cold/bookmarked visit by
    // someone who was never logged in; there's no signal here to tell them apart.
    trackEvent("auth_redirect_to_login", { redirect_route: redirectRoute });
    throw redirect("/login" + maybeRedirectParams);
  }

  return loggedInUser;
}

export async function getAuthedFetchConfig() {
  const currentUser = await getLoggedInUser();
  const idToken = "await auth.currentUser?.getIdToken()";

  if (!idToken) {
    throw new Error(
      "No ID token found to populate request headers. User may not be authenticated",
    );
  }

  return {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
}

export async function getLoggedInUserWithCustomClaims() {
  const loggedInUser = await getLoggedInUser();

  if (!loggedInUser) {
    return null;
  }

  return {
    ...loggedInUser,
  };
}

export async function getDecoratedProjectsForLoggedInUser() {
  const loggedInUser = await getLoggedInUser();

  if (!loggedInUser) {
    return null;
  }

  const { email } = loggedInUser;

  const allUserRoles = Object.values(USER_ROLES).map(role => role.name);

  const allProjectsForUser = [];

  return allProjectsForUser.map((project) => {
    const { usersByRole, partnerId, displayName } = project;
    const roles = {};

    allUserRoles.forEach(
      (role) => (roles[role] = usersByRole[role].includes(email)),
    );

    return {
      ...project,
      displayName: displayName || partnerId,
      roles,
    };
  });
}
